/**
 * Get the extension from a filename if it exists.
 *
 * @param {string} fileName - The filename to process
 * @returns {string} The filename extension
 */
export function getExtension(fileName: string): string {
  // Handle dot files
  if (fileName.startsWith('.') && fileName.indexOf('.', 1) === -1) {
    return '';
  }

  const lastDotIndex = fileName.lastIndexOf('.');
  if (lastDotIndex === -1) {
    return '';
  }

  const extension = fileName.slice(lastDotIndex + 1);
  if (extension.length <= 1) {
    return '';
  }

  return extension.toLowerCase();
}
